let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("39MC3")).then(() => parcelRequire('5zAN7'));